import { render, staticRenderFns } from "./btnGroup.vue?vue&type=template&id=0d048cb8&"
import script from "./btnGroup.vue?vue&type=script&lang=js&"
export * from "./btnGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports